module.exports = __webpack_public_path__ + "img/pie_chart.89b485b7.svg";